import { ProgramChangesExportStepCtrl } from './program-changes-export.controller';

export const ProgramChangesExportStepComponent = {
  controller: ProgramChangesExportStepCtrl,
  bindings: {
    nextStep: '&',
    prevStep: '&',
    courseDiffs: '<',
    selectedGradDate: '<',
  },
  template: require('./program-changes-export.html'),
};
